
























import { Component, Prop, Vue } from 'vue-property-decorator';

import Assets from '@/constants/assets';

import Btn, {
  BtnWidth,
  BtnColor,
} from '@/shared/components/btn.component.vue';

@Component({
  components: {
    Btn,
  },
})

export default class EmptyState extends Vue {
  @Prop({ default: '' }) private emptyStateContainerClass!: string;
  @Prop({ default: '' }) private emptyStateText!: string;
  @Prop({ default: false }) private comeBack!: boolean;
  @Prop({ default: '' }) private comeBackText!: string;
  @Prop({ default: '' }) private comeBackButtonText!: string;

  // DATA
  private assets = Assets;
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;

  // METHODS
  private emitComeBack() {
    this.$emit('come-back');
  }
}
